import React from "react";
import { Wheel } from "react-custom-roulette";
import {
	WheelContainer,
	OuterBadge,
	SpinButton,
	ButtonWrapper,
	SpinStartWrapper,
} from "../SpinHome.style";
import { t } from "i18next";
import { BURMESE_LANGUAGE_CODE_LK } from '@constants';
import { localStorage } from '@utils';
const textColors = [
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
	"#ffffff",
];
const backgroundColors = [
	"#FC5490",
	"#4B62EF",
	"#EAAD3F",
	"#4B62EF",
	"#FC5490",
	"#4B62EF",
	"#EAAD3F",
	"#4B62EF",
];


const props = {
	textColors,
	backgroundColors,
	fontFamily: "Libre Franklin",
	fontWeight: "bolder",
	fontSize: 19,
	radiusLineWidth: 0,
	outerBorderWidth: 0,
	innerBorderColor: "#FFA500",
	innerBorderWidth: 6,
	innerRadius: 0,
	textDistance: 67,
};

const SpinWheel = ({
	handleSpinClicked,
	started,
	winningIndex,
	spinValues,
	handleStop,
	goToHistory,
	goToRule,
}) => {
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();
	return (
		<div
			style={{
				position: "relative",
			}}
		>
			<WheelContainer>
				<Wheel
					disableInitialAnimation={true}
					mustStartSpinning={started}
					prizeNumber={winningIndex}
					data={spinValues}
					onStopSpinning={handleStop}
					onClick={handleSpinClicked}
					{...props}
				/>
				<OuterBadge />
				<SpinStartWrapper 
					onClick={handleSpinClicked}
					burmese={ userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? 'true' : 'false'}
				>
					{t("spin.start")}
				</SpinStartWrapper>
			</WheelContainer>
			<ButtonWrapper>
				<SpinButton isRule={true} onClick={goToRule}>
					{" "}
					{t("spin.rule")}{" "}
				</SpinButton>
				<SpinButton onClick={goToHistory}> {t("spin.history")} </SpinButton>
			</ButtonWrapper>
		</div>
	);
};

export default SpinWheel;
